module.exports = __webpack_public_path__ + "img/btnCard-2.501149f3.jpg";